var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 255h30v30h-30zm0 0",
    "data-original": "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.5 0C197.84375 0 107 90.839844 107 202.5c0 39.570312 11.417969 76.519531 31.117188 107.742188l-124.9375 124.9375C4.679688 443.679688 0 454.980469 0 467s4.679688 23.320312 13.179688 31.820312S32.980469 512 45 512s23.320312-4.683594 31.820312-13.179688l124.9375-124.9375C232.984375 393.582031 269.929688 405 309.5 405 421.160156 405 512 314.160156 512 202.5S421.160156 0 309.5 0zM55.605469 477.605469C52.773438 480.441406 49.007812 482 45 482s-7.773438-1.5625-10.605469-4.394531S30 471.007812 30 467s1.5625-7.773438 4.394531-10.605469l78.882813-78.886719 21.214844 21.214844zm100.097656-100.097657-21.210937-21.210937 21.671874-21.675781c6.542969 7.582031 13.632813 14.671875 21.214844 21.214844zM309.5 375C214.382812 375 137 297.617188 137 202.5S214.382812 30 309.5 30 482 107.382812 482 202.5 404.617188 375 309.5 375zm0 0",
    "data-original": "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.5 60C230.925781 60 167 123.925781 167 202.5S230.925781 345 309.5 345 452 281.074219 452 202.5 388.074219 60 309.5 60zm0 255C247.46875 315 197 264.53125 197 202.5S247.46875 90 309.5 90 422 140.46875 422 202.5 371.53125 315 309.5 315zm0 0",
    "data-original": "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309.5 120c-24.8125 0-45 20.1875-45 45h30c0-8.269531 6.730469-15 15-15s15 6.730469 15 15c0 3.691406-1.355469 7.242188-3.824219 10L294.5 204.273438V225h30v-9.269531L343.035156 195C350.429688 186.738281 354.5 176.085938 354.5 165c0-24.8125-20.1875-45-45-45zm0 0",
    "data-original": "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearches);
export default __webpack_public_path__ + "static/media/researches.bdec3d58a7baf6af52b49db8f93b0a72.svg";
export { ForwardRef as ReactComponent };